"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var QuoteComponents_1 = require("QuoteV2/Components/QuoteComponents");
var QuoteProductItemBuilder_1 = __importDefault(require("QuoteV2/Models/QuoteItemBuilders/QuoteProductItemBuilder"));
var QuoteSectionStore_1 = require("QuoteV2/Stores/QuoteSectionStore");
var react_1 = __importDefault(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var QuoteProductStore_1 = require("../QuoteProductStore/QuoteProductStore");
var DragDropHandler = (function (_super) {
    __extends(DragDropHandler, _super);
    function DragDropHandler() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.depthCounter = 0;
        _this.elementRef = react_1.default.createRef();
        _this.updateIndicatorPosition = function (event) {
            if (_this.elementRef.current) {
                event.preventDefault();
                var _a = _this.elementRef.current.getBoundingClientRect(), top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
                var clientX = event.clientX, clientY = event.clientY;
                if (_this.props.direction === QuoteComponents_1.DragDropHandlerDirection.Vertical) {
                    var distanceFromTop = clientY - top;
                    var distanceFromBottom = bottom - clientY;
                    _this.dropIndicatorPosition =
                        distanceFromTop < distanceFromBottom
                            ? QuoteComponents_1.DragDropHandlerIndicatorPosition.Before
                            : QuoteComponents_1.DragDropHandlerIndicatorPosition.After;
                }
                else if (_this.props.direction === QuoteComponents_1.DragDropHandlerDirection.Horizontal) {
                    var distanceFromLeft = clientX - left;
                    var distanceFromRight = right - clientX;
                    _this.dropIndicatorPosition =
                        distanceFromLeft < distanceFromRight
                            ? QuoteComponents_1.DragDropHandlerIndicatorPosition.Before
                            : QuoteComponents_1.DragDropHandlerIndicatorPosition.After;
                }
            }
        };
        _this.handleDragOver = function (event) {
            event.preventDefault();
            _this.updateIndicatorPosition(event);
        };
        _this.handleDragEnter = function (event) {
            if (_this.depthCounter === 0) {
                _this.updateIndicatorPosition(event);
            }
            _this.depthCounter++;
        };
        _this.handleDragLeave = function () {
            _this.depthCounter--;
            if (_this.depthCounter === 0) {
                _this.dropIndicatorPosition = undefined;
            }
        };
        _this.handleDrop = function (event) {
            var _a;
            var _b = _this.props, section = _b.section, item = _b.item;
            event.stopPropagation();
            var productToken = _this.quoteProductStore.productToken;
            section.addLineItems(QuoteProductItemBuilder_1.default.new()
                .withToken(productToken)
                .withProductItemProperties(_this.quoteProductStore.fetchedProductTokenItemProperties)
                .forSectionDisplayMode(section.displayMode)
                .build(), item.id, (_a = {},
                _a[QuoteComponents_1.DragDropHandlerIndicatorPosition.Before] = QuoteSectionStore_1.InsertPosition.Before,
                _a[QuoteComponents_1.DragDropHandlerIndicatorPosition.After] = QuoteSectionStore_1.InsertPosition.After,
                _a)[_this.dropIndicatorPosition]);
            _this.quoteTelemetry.trackAddLineItem(Types_1.QuoteItemType.Product, section.displayMode, QuoteTelemetry_1.AddLineItemSource.Drag, {
                providerType: productToken.substitutionToken.providerType,
                objectType: _this.quoteProductStore.objectType,
            });
            _this.depthCounter = 0;
            _this.dropIndicatorPosition = undefined;
        };
        return _this;
    }
    DragDropHandler.prototype.componentDidMount = function () {
        var _this = this;
        this.clearDropIndicatorPositionAutorunner = (0, mobx_1.autorun)(function () {
            var _a;
            if (((_a = _this.dragStore.dragItemIfCurrent(DragStore_1.DragType.Variable)) === null || _a === void 0 ? void 0 : _a.token.dataType) !== Types_2.TokenDataType.ProductList) {
                (0, mobx_1.runInAction)(function () {
                    _this.dropIndicatorPosition = undefined;
                });
            }
        });
    };
    DragDropHandler.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.clearDropIndicatorPositionAutorunner) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    Object.defineProperty(DragDropHandler.prototype, "childArguments", {
        get: function () {
            var _a, _b;
            return {
                indicatorPosition: this.dropIndicatorPosition,
                isDraggingProductListToken: ((_a = this.dragStore.dragItemIfCurrent(DragStore_1.DragType.Variable)) === null || _a === void 0 ? void 0 : _a.token.dataType) === Types_2.TokenDataType.ProductList,
                dragHandlers: ((_b = this.dragStore.dragItemIfCurrent(DragStore_1.DragType.Variable)) === null || _b === void 0 ? void 0 : _b.token.dataType) === Types_2.TokenDataType.ProductList
                    ? {
                        ref: this.elementRef,
                        onDragEnter: this.handleDragEnter,
                        onDragLeave: this.handleDragLeave,
                        onDragOver: this.handleDragOver,
                        onDrop: this.handleDrop,
                    }
                    : { ref: this.elementRef },
            };
        },
        enumerable: false,
        configurable: true
    });
    DragDropHandler.prototype.render = function () {
        var children = this.props.children;
        return react_1.default.createElement(react_1.default.Fragment, null, children(this.childArguments));
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        (0, inversify_react_1.resolve)("dragStore"),
        __metadata("design:type", typeof (_a = typeof DragStore_1.DragStore !== "undefined" && DragStore_1.DragStore) === "function" ? _a : Object)
    ], DragDropHandler.prototype, "dragStore", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof QuoteProductStore_1.QuoteProductStore !== "undefined" && QuoteProductStore_1.QuoteProductStore) === "function" ? _b : Object)
    ], DragDropHandler.prototype, "quoteProductStore", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_c = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _c : Object)
    ], DragDropHandler.prototype, "quoteTelemetry", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_d = typeof QuoteComponents_1.DragDropHandlerIndicatorPosition !== "undefined" && QuoteComponents_1.DragDropHandlerIndicatorPosition) === "function" ? _d : Object)
    ], DragDropHandler.prototype, "dropIndicatorPosition", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", typeof (_e = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _e : Object)
    ], DragDropHandler.prototype, "usingFeature", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DragDropHandler.prototype, "updateIndicatorPosition", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DragDropHandler.prototype, "handleDragOver", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DragDropHandler.prototype, "handleDragEnter", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DragDropHandler.prototype, "handleDragLeave", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DragDropHandler.prototype, "handleDrop", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DragDropHandler.prototype, "childArguments", null);
    DragDropHandler = __decorate([
        mobx_react_1.observer
    ], DragDropHandler);
    return DragDropHandler;
}(react_1.default.Component));
exports.default = DragDropHandler;
